export default __webpack_public_path__ + "static/media/planet8.49bdc546.png";